import {
  compose,
  complement,
  difference,
  endsWith,
  equals,
  filter,
  flatten,
  isNil,
  keys,
  map,
  mergeAll
} from 'ramda'
import { AnyObject } from '@/models/helpers/common'
import { router } from '@/router'

export type Params = {
  pageSize?: number
  current?: number
  order?: Order
  sort?: string
  /** TODO */
  filter?: string[]
  /** TODO */
  query?: QueryParam[]
  /** TODO */
  queryJoin?: QueryJoin
}
export type QueryParam = {
  field: string
  value: string | number
  method: QueryMethod
}
export type QueryMethod = '=' | '>' | '<' | '>=' | '<=' | 'LIKE'
export type QueryJoin = 'and' | 'or'
export type Order = 'asc' | 'desc'
type KevValuePair = { key: string; value: any }

const QUERY_METHOD_SUFFIX = '-method'
const QUERY_CURRENT_PAGE = 'current'
const QUERY_PAGE_SIZE = 'page-size'

const paramFormatter = (param: QueryParam) => ({
  [param.field]: param.value,
  [param.field + QUERY_METHOD_SUFFIX]: param.method
})
const queryParser = (query: AnyObject) => (field: string): QueryParam => ({
  field,
  value: query[field],
  method: query[field + QUERY_METHOD_SUFFIX] || '='
})

const mapparamFormatter = map(paramFormatter)
const mergeQuery = compose(mergeAll, mapparamFormatter)

const parseQuery = (query: AnyObject, params: string[]) => {
  try {
    const parse = compose(
      map(queryParser(query)),
      filter(params.includes),
      keys as (data: AnyObject) => string[]
    )
    return parse(query)
  } catch (e) {
    // TODO where error from
    return []
  }
}

const mergeParams = (oldParams: QueryParam[], newParams: QueryParam[]) =>
  oldParams
    .filter(a => !newParams.find(b => a.field === b.field))
    .concat(newParams)
    .filter(a => !isNil(a.value) && a.value !== '')

const notInclude = (params: string[]) =>
  compose(
    flatten as (list: string[][]) => string[],
    map((a: string) => [a, a + QUERY_METHOD_SUFFIX]),
    difference(params),
    keys as (data: AnyObject) => string[]
  )

const keysNotEndWithMethod = compose(
  filter(complement(endsWith(QUERY_METHOD_SUFFIX))),
  keys
)

export const refreshQuery = (params: Params) => {
  const query: AnyObject = {
    ...router.currentRoute.query,
    [QUERY_CURRENT_PAGE]: params.current,
    [QUERY_PAGE_SIZE]: params.pageSize,
    ...mergeQuery(params.query || [])
  }

  // remove empty params
  const paramFields: any[] = [] // TODO
  const deletePropertys = map((key: string) =>
    Reflect.deleteProperty(query, key)
  )
  deletePropertys(notInclude(paramFields)(params))
  if (!equals(query, router.currentRoute.query)) {
    router.replace({ ...router.currentRoute, query } as any)
  }
}

export const decodeQuery = () => {
  // TODO how to notify table-column
  const re: KevValuePair[] = []

  const query = router.currentRoute.query
  const current = Number.parseInt(query.currentPage as string)
  const size = Number.parseInt(query.pageSize as string)

  if (current) re.push({ key: QUERY_CURRENT_PAGE, value: current })
  if (size) re.push({ key: QUERY_PAGE_SIZE, value: size })

  const paramFields: string[] = [] // TODO
  const searchParams: QueryParam[] = [] // TODO

  const params = parseQuery(router.currentRoute.query, paramFields)
  re.push({ key: 'searchParams', value: mergeParams(searchParams, params) })
  return params
}
